<form #eventsForm="ngForm">
  <h5>{{locale.LABEL_PREFAB_PROPS_EVENTS}}</h5>
  <table class="properties-table events wm-table header-fixed">
    <thead>
    <tr>
      <th class="app-label required pty-evt-name event-name">{{locale.LABEL_NAME}}</th>
      <th class="app-label pty-evt-display-name event-name">{{locale.LABEL_PREFAB_PROPS_DISPLAY_NAME}}</th>
      <th class="app-label required pty-evt-desc event-description">{{locale.LABEL_DESCRIPTION}}</th>
      <th class="pty-delete"></th>
    </tr>
    </thead>
    <tbody>
    <!----------- Load ----------->
    <tr>
      <td>
        <div class="input-group">
          <div class="input-group-addon">{{locale.LABEL_ON | lowercase}}</div>
          <input class="app-textbox form-control pty-name-field" pattern="^\w*$" disabled title="{{locale.MESSAGE_EVENTS_READONLY}}" value="Load">
        </div>
      </td>

      <td>
        <div class="input-group">
          <div class="input-group-addon">{{locale.LABEL_ON}} </div>
          <input class="app-textbox form-control pty-name-field" pattern="^\w*$" disabled title="{{locale.MESSAGE_EVENTS_READONLY}}" value="Load">
        </div>
      </td>

      <td>
        <input class="app-textbox form-control pty-desc-field" disabled title="{{locale.TITLE_PREFAB_EVENTS_DESC}}" value="{{locale.MESSAGE_PREFAB_EVENT_ONLOAD}}">
      </td>

      <td>
        <button type="button" class="btn app-button btn-transparent" disabled title="{{locale.TITLE_PREFAB_PROPS_DELETE_PROPERTY}}">
          <i class="wm-icon wms wms-delete"></i>
        </button>
      </td>
    </tr>
    <!----------- Destroy ----------->
    <tr>
      <td>
        <div class="input-group">
          <div class="input-group-addon">{{locale.LABEL_ON | lowercase}}</div>
          <input class="app-textbox form-control pty-name-field" pattern="^\w*$" disabled title="{{locale.MESSAGE_EVENTS_READONLY}}" value="Destroy">
        </div>
      </td>

      <td>
        <div class="input-group">
          <div class="input-group-addon">{{locale.LABEL_ON}} </div>
          <input class="app-textbox form-control pty-name-field" pattern="^\w*$" disabled title="{{locale.MESSAGE_EVENTS_READONLY}}" value="Destroy">
        </div>
      </td>

      <td>
        <input class="app-textbox form-control pty-desc-field" disabled title="{{locale.TITLE_PREFAB_EVENTS_DESC}}" value="{{locale.MESSAGE_PREFAB_EVENT_DESTROY}}">
      </td>

      <td>
        <button type="button" class="btn app-button btn-transparent" disabled title="{{locale.TITLE_PREFAB_PROPS_DELETE_PROPERTY}}">
          <i class="wm-icon wms wms-delete"></i>
        </button>
      </td>
    </tr>

    <tr *ngFor="let event of events">
      <td>
        <div class="input-group">
          <div class="input-group-addon">{{locale.LABEL_ON | lowercase}}</div>
          <input class="app-textbox form-control pty-name-field" pattern="^\w*$" required
                 [name]="'name-' + event.name" title="{{locale.MESSAGE_EVENT_NAME_PATTERN}}" placeholder="{{locale.MESSAGE_EVENT_NAME_PATTERN}}"
                 [(ngModel)]="event.name" [ngModelOptions]="{updateOn: 'change'}"
                 (change)="validateEvents(event, false)">
        </div>
      </td>
      <td>
        <div class="input-group">
          <div class="input-group-addon">{{locale.LABEL_ON}}</div>
          <input class="app-textbox form-control evt-display-name"
                 [name]="'displayName-' + event.displayName" title="{{locale.MESSAGE_EVENT_DISPLAY_NAME}}" placeholder="{{locale.MESSAGE_EVENT_DISPLAY_NAME}}"
                 [(ngModel)]="event.displayName" [ngModelOptions]="{updateOn: 'change'}">
        </div>
      </td>
      <td>
        <input class="app-textbox form-control pty-desc-field"
               [(ngModel)]="event.description" [ngModelOptions]="{updateOn: 'change'}"
               [name]="'description-' + event.description" title="{{locale.TITLE_PREFAB_EVENTS_DESC}}" placeholder="{{locale.TITLE_PREFAB_EVENTS_DESC}}" required>
      </td>
      <td>
        <button type="button" class="btn app-button btn-transparent" (click)="removeEvent(event)" title="{{locale.TITLE_PREFAB_PROPS_DELETE_PROPERTY}}">
          <i class="wm-icon wms wms-delete"></i>
        </button>
      </td>
    </tr>
    <tr>
      <td>
        <div class="input-group">
          <div class="input-group-addon">{{locale.LABEL_ON | lowercase}}</div>
          <input class="app-textbox form-control pty-name-field"
                 [(ngModel)]="newProps['event']['name']" [ngModelOptions]="{updateOn: 'change'}"
                 name="new-event-name" pattern="^\w*$" title="{{locale.MESSAGE_EVENT_NAME_PATTERN}}" placeholder="{{locale.MESSAGE_EVENT_NAME_PATTERN}}"
                 (change)="validateEvents(newProps['event'], true)">
        </div>
      </td>
      <td>
        <div class="input-group">
          <div class="input-group-addon">{{locale.LABEL_ON}} </div>
          <input class="app-textbox form-control evt-display-name" title="{{locale.MESSAGE_EVENT_DISPLAY_NAME}}" placeholder="{{locale.MESSAGE_EVENT_DISPLAY_NAME}}"
                 name="new-event-displayName" [(ngModel)]="newProps['event']['displayName']" [ngModelOptions]="{updateOn: 'change'}">
        </div>
      </td>
      <td>
        <input class="app-textbox form-control pty-desc-field" title="{{locale.TITLE_PREFAB_EVENTS_DESC}}" placeholder="{{locale.TITLE_PREFAB_EVENTS_DESC}}"
               name="new-event-description" [(ngModel)]="newProps['event']['description']" [ngModelOptions]="{updateOn: 'change'}">
      </td>
      <td></td>
    </tr>
    </tbody>
  </table>
</form>
